import { Box, Grid, Typography, useTheme } from "@mui/material";

export default function Footer() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        px: 10,
        py: 4,
        bgcolor: theme.palette.primary.main,
        textAlign: "left",
      }}
    >
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 4, md: 3, lg: 2 }}>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white, fontWeight: "bold" }}
          >
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.crew324.com"
                style={{
                  textDecoration: "none",
                  color: theme.palette.custom.white,
                }}
              >
                Crew 324
              </a>{" "}
              - La Mesa, CA
            </>
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white, fontSize: "0.675rem" }}
          >
            A proud part of the Fletcher Hills Kiwanis Club Charitable Fund.
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white, fontSize: "0.675rem" }}
          >
            A California registered non-profit organization.
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white, fontSize: "0.675rem" }}
          >
            EIN: 33-0719745
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white, fontSize: "0.675rem" }}
          >
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.scouting.org/"
              style={{
                textDecoration: "none",
                color: theme.palette.custom.white,
              }}
            >
              https://www.scouting.org/
            </a>
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.custom.white, fontSize: "0.675rem" }}
          >
            v{window._env_.REACT_APP_VERSION || "unknown"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 4, md: 6, lg: 8 }} />
        <Grid
          size={{ xs: 12, sm: 4, md: 3, lg: 2 }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Grid container spacing={2}>
            <Grid size={{ sm: 4 }}>
              <img
                alt="kiwanis-logo"
                src="/kiwanis.png"
                width="45px"
                height="45px"
              />
            </Grid>
            <Grid size={{ sm: 4 }}>
              <img alt="bsa-logo" src="/bsa.png" width="45px" height="45px" />
            </Grid>
            <Grid size={{ sm: 4 }}>
              <img
                alt="venture-logo"
                src="/venture.png"
                width="45px"
                height="45px"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
